documentsToCollect.classy.controller({
    name: 'RetroModalController',
    inject: ['index', '$scope', 'authServiceFactory', 'DateService', 'ModelService', 'TaxSettingAffectedFamiliesModelService',
        'SchoolTaxModelService', 'SchoolModelService', 'DocumentsModelService', 'StandardModalCudFactory', '$modalInstance'],
    init: function()
    {
        this.$.TaxSettingAffectedFamiliesModelService = this.TaxSettingAffectedFamiliesModelService;
        this.$.$modalInstance = this.$modalInstance;
    },
    retroApply: function()
    {
        var parent =this;
        this.TaxSettingAffectedFamiliesModelService.put(this.authServiceFactory.getAuth().schoolID, {}).then(function(response)
        {
            parent.$modalInstance.dismiss('cancel')
        })
    }

});